import { DocumentError } from 'apiConnector/document/document';
import { NextWorkflowError } from 'models/NextWorkflowError';

export function ErrorContent({ error, severity }: { error: DocumentError; severity: 'danger' | 'warning' }) {
  if (error.type === 'END_USER_ERROR') {
    return <EndUserErrorContent message={error.errorMessages.join(', ')} severity={severity} />;
  }
  if (error.type === 'REJECTION') {
    return <RejectionErrorContent rejections={error.rejections} severity={severity} />;
  }
  if (error.type === 'TECHNICAL') {
    return (
      <TechnicalErrorContent message="A technical error occurred while downloading the document." severity={severity} />
    );
  }
  return <pre>{JSON.stringify(error, null, 2)}</pre>;
}

function EndUserErrorContent({ message, severity }: { message: string; severity: 'danger' | 'warning' }) {
  return <div className={`text-${severity} p-2`}>{message}</div>;
}

function TechnicalErrorContent({ message, severity }: { message: string; severity: 'danger' | 'warning' }) {
  return <div className={`text-${severity} p-2`}>{message}</div>;
}

function RejectionErrorContent({
  rejections,
  severity,
}: {
  rejections: NextWorkflowError[];
  severity: 'danger' | 'warning';
}) {
  return (
    <ul className={`text-${severity} p-2`}>
      {rejections.map(({ rejectionMessage }, idx) => (
        <li key={idx}>{rejectionMessage}</li>
      ))}
    </ul>
  );
}
